<section
  class="landing-a__section landing-a__section--muted landing-a__case-showcase-section"
  id="case-management"
  appLandingReveal="landing-a__case-showcase-section--visible"
>
  <div class="landing-a__container">
    <div class="landing-a__case-showcase-grid">
      <div class="landing-a__case-showcase-copy">
        <span class="landing-a__section-kicker">
          {{ 'landing.landing_1.recovery_statement.kicker' | translate }}
        </span>
        <h2 class="landing-a__case-showcase-title">
          {{ 'landing.landing_1.recovery_statement.title' | translate }}
        </h2>
        <p class="landing-a__case-showcase-subtitle">
          {{ 'landing.landing_1.recovery_statement.subtitle' | translate }}
        </p>
      </div>

      <div class="landing-a__case-showcase-cards">
        @for (bullet of bullets; track bullet.key) {
          <article class="landing-a__case-showcase-card">
            <div class="landing-a__case-showcase-card-icon" aria-hidden="true">
              <i-tabler [name]="bullet.icon"></i-tabler>
            </div>
            <div class="landing-a__case-showcase-card-body">
              <h3>
                {{ 'landing.landing_1.recovery_statement.bullets.' + bullet.key + '.title' | translate }}
              </h3>
              <p>
                {{ 'landing.landing_1.recovery_statement.bullets.' + bullet.key + '.description' | translate }}
              </p>
            </div>
          </article>
        }
      </div>
    </div>
  </div>
</section>